import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 3l3 5.063","key":"svg-0"}],["path",{"d":"M5 12l6 6","key":"svg-1"}],["path",{"d":"M5 18l6 -6","key":"svg-2"}],["path",{"d":"M21 3l-4.8 9","key":"svg-3"}]]

/**
 * IconXPowerY
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXIteC1wb3dlci15Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSAzbDMgNS4wNjMiIC8+CiAgPHBhdGggZD0iTTUgMTJsNiA2IiAvPgogIDxwYXRoIGQ9Ik01IDE4bDYgLTYiIC8+CiAgPHBhdGggZD0iTTIxIDNsLTQuOCA5IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/x-power-y
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconXPowerY = createReactComponent('outline', 'x-power-y', 'XPowerY', __iconNode);

export default IconXPowerY;